import styled from 'styled-components';

export const Content = styled.div`
    width: 100%;
    min-width: 960px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
`;

export const Card = styled.div`
    width: 360px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
`;
